import React from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Field } from "./Field";
import styled from "styled-components";

const CrawlScopeField = ({ crawlScope }) => {
    const { workspaceNumber } = useParams();
    const websiteUrl = useSelector(s => s.workspaces.current.websiteUrl);

    const isInternal = crawlScope === 'INTERNAL';
    const isKnown = crawlScope === 'INTERNAL' || crawlScope === 'EXTERNAL';
    return (
        <Field
            diffDisabled
            fieldName="Crawl Scope"
            fieldValueCur={
                !isKnown ? <span style={{ color: '#94a3b8', fontSize: '0.8rem' }}>Unknown</span> :
                <ScopeWrap>
                    <ScopeLabel $internal={isInternal}>
                        {isInternal ? 'Internal' : 'External'}
                    </ScopeLabel>
                    <ScopeDesc>
                        {isInternal
                            ? <>This page is within the configured crawl scope{websiteUrl && <> ({websiteUrl})</>}. <SettingsLink to={`/ws/${workspaceNumber}/admin`}>Workspace settings</SettingsLink></>
                            : <>This page is outside the configured crawl scope{websiteUrl && <> ({websiteUrl})</>}. <SettingsLink to={`/ws/${workspaceNumber}/admin`}>Workspace settings</SettingsLink></>
                        }
                    </ScopeDesc>
                </ScopeWrap>
            }
        />
    );
};

export default CrawlScopeField;

const ScopeWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 3px;
`;

const ScopeLabel = styled.span`
    font-size: 0.78rem;
    font-weight: 700;
    color: ${({ $internal }) => $internal ? '#15803d' : '#b45309'};
`;

const ScopeDesc = styled.span`
    font-size: 0.72rem;
    color: #64748b;
    line-height: 1.4;
`;

const SettingsLink = styled(Link)`
    color: #6366f1;
    text-decoration: none;
    font-weight: 600;
    &:hover { text-decoration: underline; }
`;
